// extracted by mini-css-extract-plugin
export default {"top-section":"_1amwwtz","topSection":"_1amwwtz","app-icon":"_1c5hb17","appIcon":"_1c5hb17"};